export { default } from './EmptyMessage'



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/EmptyMessage/index.js